module.exports = __webpack_public_path__ + "img/emo_52.edfe69e1.gif";